import React from "react";
import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import {MdErrorOutline} from "react-icons/md";
import Button from "../../newComponents/button/Button";
import {GoCheckCircle, GoQuestion} from "react-icons/go";


const ConfirmModal = ({
                        title = "",
                        message = "آیا مطمئن هستید؟",
                        showConfirmButton = false,
                        showCancelButton = true,
                        showIcon = true,
                        confirmButtonText="ادامه",
                        confirmButtonTheme="primary",
                        cancelButtonTheme="link",
                        cancelButtonText="بستن",
                        icon=null,
                        onConfirm = () => {
                        },
                        onCancel = () => {
                        }
                    }) => {



    return <ModalWrapper animation="slideUp"
                         contentContainerClassName="w-11/12 md:w-5/12 fixed w-full bottom-0 bg-gray-50 lg:w-4/12 p-5 rounded-t-lg">
        <div className="flex flex-col justify-center items-center w-full">
            {showIcon &&!icon&& <GoQuestion className="text-primary mb-4 text-4xl"/>}
            {showIcon &&icon&& icon}
            {!showIcon &&!icon&& <></>}

            <h1 className="font-bold text-primary">{title}</h1>
            <p className="text-sm mt-1 mb-5 ">{message}</p>
            <div
                className={`w-full grid  gap-2 border-t pt-5 ${(showConfirmButton && showCancelButton) ? 'grid-cols-2' : 'grid-cols-1'}`}>
                {showCancelButton && <Button className="rounded" onClick={onCancel}  theme={cancelButtonTheme}>{cancelButtonText}</Button>}
                {showConfirmButton && <Button className="rounded" onClick={onConfirm} theme={confirmButtonTheme}>{confirmButtonText}</Button>}



            </div>
        </div>
    </ModalWrapper>
}
export default ConfirmModal;